import { request } from "apis/base";
import { CommonParamsType } from "constants/types/common";
import { ProductRequestBodyType, ProductUpdateBodyType } from "constants/types/product";

type ProductExportParams = Pick<CommonParamsType, "search">;

export const productApi = {
  getAll: (params?: CommonParamsType) => {
    return request({ url: "/product", method: "GET", params });
  },

  export: (params?: ProductExportParams) => {
    return request({ url: "/product/export", method: "GET", params, responseType: "blob" });
  },

  getById: (id: string) => {
    return request({ url: `/product/${id}`, method: "GET" });
  },

  create: (data: ProductRequestBodyType) => {
    return request({ url: "/product", method: "POST", data });
  },

  update: (id: string, data: ProductUpdateBodyType) => {
    return request({ url: `/product/${id}`, method: "PUT", data });
  },

  delete: (id: string) => {
    return request({ url: `/product/${id}`, method: "DELETE" });
  },
};
